import { z } from "zod";
import { SectionSpacingSchema } from "../../../../../zod/shared-schemas.mjs";
const ContentSectionFootnoteSchema = z.object({
  data: z.object({
    id: z.string().optional().nullable(),
    text: z.string()
  }).merge(SectionSpacingSchema)
});
export default ContentSectionFootnoteSchema;
